module.exports = {
  apiHost: 'https://testapi.dayafternow.com',
  clientHost: 'http://client-test.dayafternow.com/app',
  master: 'http://client-test.dayafternow.com',
  recaptcha: {
    sitekey: '6Ld9HyMUAAAAANRcOyDZMjVL3zT9XEPRx-Jw6iI9'
  },
  stripe: {
    pk: 'pk_test_fw7X1opkGhOhEemOGiKA6aBL'
  },
  gaKey: 'UA-103026428-1',
  paypal: {
    client: {
      sandbox: 'AVcQixk6VxPtfSMX_6yWG8PxGnPkYXrk1fPrvRUrMzX6BpYEjXBNpwvXGwECiwTIttiipuDPuzABEmdp',
      production: ''
    },
    env: 'sandbox',
    style: {
      label: 'pay', // checkout | credit | pay
      size: 'responsive',    // small | medium | responsive
      shape: 'rect',     // pill | rect
      color: 'silver',     // gold | blue | silver
      tagline: false  // remove tagline
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/config.js